import { getDataMapper, getObjectId, mapField } from "@/shared";

export const mapServiceToServer = getDataMapper({
    title: mapField("title", String),
    price: mapField("price", Number),
    point: mapField("point"),
    discounts: mapField("discounts", getObjectId),
});
